import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import { getDaoContract } from "./contractHelper";
import { MulticallContractWeb3 } from "./useContracts";

export const useVotersStats = (proposalId = 0, pageId = 1) => {
    const [stats, setStats] = useState({
        voterList: [],
        loading: true,
        totalLength: [],
        totalPages: 0,
        page: 1,
    });

    const daoContract = getDaoContract();

    useEffect(() => {
        const fetch = async () => {
            try {

                setStats({
                    ...stats,
                    loading: true
                })

                const totalLength = await MulticallContractWeb3([
                    daoContract.methods.proposalVotelength(proposalId), //0
                ])

                var totalRecords = totalLength[0];
                var recordsPerPage = 5;
                var totalPages = Math.ceil(totalRecords / recordsPerPage);

                let data = [];
                if (totalRecords > 0) {
                    var paginationInfo = calculatePagination(totalRecords, recordsPerPage, pageId);
                    data = await MulticallContractWeb3([
                        daoContract.methods.proposalVoteInfos(proposalId, paginationInfo.startRecord, paginationInfo.endRecord) //0
                    ]);
                }


                setStats({
                    voterList: data[0],
                    loading: false,
                    totalLength: totalRecords,
                    totalPages,
                    page: pageId,
                })

            }
            catch (err) {
                console.log(err.message);
                setStats({
                    voterList: [],
                    loading: false,
                    totalLength: 0,
                    totalPages: 0,
                    page: 1,
                })
            }

        }

        if (daoContract) {
            fetch();
        }
        // eslint-disable-next-line
    }, [proposalId, pageId]);

    return stats;
}


function calculatePagination(totalRecords, recordsPerPage, pageNumber) {
    // Calculate total number of pages
    var totalPages = Math.ceil(totalRecords / recordsPerPage);

    // Adjust page number if out of range
    pageNumber = Math.min(Math.max(pageNumber, 1), totalPages);

    // Calculate start and end record numbers for pagination
    var startRecord = Math.max((pageNumber - 1) * recordsPerPage, 0);
    var endRecord = Math.min(startRecord + recordsPerPage - 1, totalRecords - 1);

    // If startRecord is 0 and endRecord is still 0 (only for the first page), adjust endRecord to 1
    if (startRecord === 0 && endRecord === 0) {
        endRecord = 1;
    }

    return {
        startRecord: startRecord,
        endRecord: endRecord
    };
}

